import * as React from 'react';
import { useState } from 'react';
import useStores from '../../hooks/useStores';
import useModal from '../../hooks/useModal';

import CardItemList from '../../components/CardItemList';
import PaymentInfo from './Container/PaymentInfo';
import PaymentConfirm from './Container/PaymentConfirm';

function Payment() {
  const [focusIndex, setFocusIndex] = useState(0);
  const { CardWallet } = useStores();
  const { Modal, modalOpen: handleModalOpen, modalClose: handleModalClose } = useModal();

  const onClickCard = (index) => {
    setFocusIndex(index);
    handleModalOpen();
  };

  const focusCardData = CardWallet.list[focusIndex];

  return (
    <>
      <div className="layout-side-container">
        <CardItemList onClickCard={onClickCard} />
      </div>

      <div className="layout-main-container bottom">
        <PaymentInfo />
      </div>

      <Modal>
        <PaymentConfirm onClickCancelButton={handleModalClose} focusCardData={focusCardData} />
      </Modal>
    </>
  );
}

export default Payment;
